export function UnlinkedZap() {
  return (
    <svg
      width="124"
      height="100"
      viewBox="0 0 124 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.3983 61.1862C61.5389 61.3268 61.7668 61.3268 61.9074 61.1862L64.1984 58.8952C64.339 58.7546 64.339 58.5266 64.1984 58.3861C64.0578 58.2455 63.8299 58.2455 63.6893 58.3861L61.6528 60.4225L59.6164 58.3861C59.4758 58.2455 59.2478 58.2455 59.1072 58.3861C58.9667 58.5266 58.9667 58.7546 59.1072 58.8952L61.3983 61.1862ZM61.6528 39.0718L61.2928 39.0718L61.2928 60.9316L61.6528 60.9316L62.0128 60.9316L62.0128 39.0718L61.6528 39.0718Z"
        fill="#B5B2AA"
      />
      <rect
        x="0.435858"
        y="1.24933"
        width="123.052"
        height="37.4636"
        rx="3.30359"
        stroke="#B5B2AA"
        strokeWidth="0.717419"
      />
      <rect
        x="0.435858"
        y="61.2904"
        width="123.052"
        height="37.4601"
        rx="3.30359"
        stroke="#B5B2AA"
        strokeWidth="0.717419"
      />
      <circle cx="9.44177" cy="11.1249" r="3.82214" fill="#B5B2AA" />
      <rect
        x="15.4453"
        y="9.19531"
        width="31.7752"
        height="3.86"
        rx="1.93"
        fill="#D7D3C9"
      />
      <rect
        x="5.61963"
        y="19.123"
        width="112.069"
        height="3.86227"
        rx="1.93113"
        fill="#D7D3C9"
      />
      <rect
        x="5.61963"
        y="27.1602"
        width="87.9558"
        height="3.86227"
        rx="1.93113"
        fill="#D7D3C9"
      />
      <path
        d="M61.6545 90.2831C64.2403 90.2831 66.7201 89.2018 68.5486 87.2772C70.377 85.3526 71.4042 82.7422 71.4042 80.0203C71.4042 77.2985 70.377 74.6881 68.5486 72.7635C66.7201 70.8388 64.2403 69.7576 61.6545 69.7576C59.0688 69.7576 56.5889 70.8388 54.7605 72.7635C52.9321 74.6881 51.9049 77.2985 51.9049 80.0203C51.9049 82.7422 52.9321 85.3526 54.7605 87.2772C56.5889 89.2018 59.0688 90.2831 61.6545 90.2831ZM66.4026 78.9941L60.6796 86.178V81.0466H56.9065L62.6295 73.8627V78.9941H66.4026Z"
        fill="#B5B2AA"
      />
    </svg>
  );
}
